import api from './APIService';

class MembershipService {
	getAll(userId) {
		return api.fetch({ method: 'get', path: `/participant/membership/${userId}`});
	}
	getOrganizations(userId) {
		return api.fetch({ method: 'get', path: '/participant/membership/organizations/' + userId });
	}
	create(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/', data });
	}
	update(data) {
		return api.fetch({ method: 'put', path: '/participant/membership/', data });
	}
	delete($userId, $organizerId) {
		return api.fetch({ method: 'delete', path: `/participant/membership/${$userId}/${$organizerId}`});
	}
	getMembershipsUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/getMembershipsUsers', data });
	}
	validateAmaNumber(data) {
		return api.fetch({ method: 'post', path: '/participant/membership/validate-ama', data });
	}
	deleteForId($membershipId) {
		return api.fetch({ method: 'delete', path: `/participant/membership/id/${$membershipId}/delete`});
	}
}

export default new MembershipService();
